module.exports =
  base: '/order/v3'






// WEBPACK FOOTER //
// ./~/oo-routes/routes/order3.coffee